<template>
  <div>
    <el-overlay-loading :loading="loading" />
    <el-autocomplete
      :items="getItems"
      itemvalue="value"
      itemtext="text"
      in-fragments
      hide-details
      :label="label"
      :disabled="disabled"
      v-model="addInput"
      @change="addItem()"
      @add-all="addAll"
      list-select
    />
    <div style="position: relative;">
      <label v-if="showList"
      class="list-select-lable">{{ subLabel }}</label>
      <v-simple-table v-if="showList"
        :class="`pt-1 table-input-box ${disabled ? 'disabled' : ''}`"
        dense>
        <tbody>
          <tr>
            <td colspan="3" style="overflow: hidden;">
              <div style="float: left;padding-top: 3px;">
                <strong>{{ `Viso: ${elValue.length}` }}</strong>
              </div>
              <div style="float: right;">
                <el-button
                small
                outlined
                class="select-input-btn mr-1"
                color="primary"
                @click.native="deleteAll()"
              >
                {{ $t('Pašalinti visas') }}
              </el-button>
              </div>
            </td>
          </tr>
          <tr v-for="(subItem, index) in elValue" :key="subItem.value">
            <td class="pa-0 pl-2" style="max-width: 48px; width: 48px;">{{index + 1}}</td>
            <td
              style="max-width: 20px; width: 20px; padding-left: 10px"
              v-if="!disabled"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    dense
                    class="table-action mx-1"
                    v-bind="attrs"
                    v-on="on"
                    @click="deleteItem(subItem)"
                  >
                    mdi-delete-outline
                  </v-icon>
                </template>
                <div class="tooltip-text">{{ $t('Pašalinti') }}</div>
              </v-tooltip>
            </td>
            <td>{{ getItem(subItem) }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ElListSelect',
  mixins: [],
  props: {
    label: String,
    subLabel: String,
    items: [Object, Array],
    itemtext: String,
    itemvalue: String,
    value: [String, Number, Object, Array, Boolean],
    disabled: Boolean,
    validateKey: String,
  },
  data() {
    return {
      loading: false,
      addInput: '',
    }
  },
  inject: {
    $validator: '$validator',
  },
  computed: {
    showList() {
      return this.elValue && this.elValue.length > 0
    },
    getItems() {
      this.elValue
      if (this.items && this.elValue) {
        let list = {}
        list.lt = this.items.lt.filter(
          (item) => !this.elValue.includes(item.value)
        )
        return list
      }
      return this.items
    },
    elValue: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
  },
  created() {},
  methods: {
    itemIsAdded(item) {
      return this.addItemList.find((element) => {
        if (item.value === element.value) {
          return true
        }
      })
    },
    addAll(list) {
      this.loading = true
      list.map(item => {
         this.elValue.push(item)
      })
      this.sortItems()
    },
    addItem() {
      if (this.addInput) {
        this.elValue.unshift(this.addInput)
        this.$nextTick(() => {
          this.addInput = ''
        })
        this.sortItems()
      }
    },
    sortItems(){
      let objectArr = []
      this.elValue.map(key => {
        let item = this.items.lt.find((element) => {
          return element.value == key
        })
        objectArr.push(item) 
      })
      let sorted = objectArr.sort((a, b) => {
          return a.text.localeCompare(b.text);
      });
      this.elValue = sorted.map(obj => obj.value);
      this.$nextTick(() => {
        this.loading = false
      })
    },
    getItem(subItem) {
      if (this.items) {
        let item = this.items.lt.find((element) => {
          return element.value == subItem
        })
        return item ? item.text : ''
      }
      return ''
    },
    deleteAll(){
      this.elValue = []
    },
    deleteItem(item) {
      this.elValue = this.elValue.filter(element => element !== item);
      // const index = this.elValue.findIndex((element) => {
      //   return item == element
      // })
      // if (index > -1) {
      //   this.elValue.splice(index, 1)
      // }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/elements.scss';
.table-input-box {
  margin-top: 25px;
  border: 1px solid #198677;
  max-height: 450px;
  overflow: auto;
  &.disabled {
    border: 1px solid #949494;
    border-top: none;
    background-color: #e5e5e5;
    :hover {
      background-color: #e5e5e5;
    }
  }
}
.list-select-lable{
  background-color: white;
  font-size: 12px;
  color: #686868;
 line-height: 12px;
  position: absolute;
  left: 10px;
  top: -5px
}

.select-input-btn {
  height: 25px !important;
  min-width: 23px !important;
  padding: 0px 4px 0px 4px !important;
}

</style>
